import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import {
  ENTITY_QUESTIONS_FEATURE_OFF,
  EntitySuggestedQuestionsResponse,
} from 'src/app/models/home/entity-capabilities/home-entity-capabilities.model';
import { HOME_API_ROUTES } from './home-api-routes';

/**
 * Home IA · H10. Preguntas sugeridas para una entidad visible del radar R4. ACL-safe en el backend:
 * si la entidad no es visible responde 404; si el plan no tiene `knowledge_hub` responde 404 y aquí
 * se degrada a `featureAvailable=false` (ocultar los chips), sin propagar el error para no tumbar
 * /home. El resto de errores sí se propagan (los aísla el estado del widget). account/user por JWT.
 */
@Injectable({ providedIn: 'root' })
export class HomeEntityQuestionsService {
  constructor(private readonly api: ApiService) {}

  getSuggestedQuestions(entityId: string): Observable<EntitySuggestedQuestionsResponse> {
    return this.api
      .get<EntitySuggestedQuestionsResponse>(HOME_API_ROUTES.ENTITY_SUGGESTED_QUESTIONS(entityId))
      .pipe(
        catchError((error) => {
          // 404 = feature no disponible o entidad no visible: ocultar chips, no es error de UI.
          if (error?.status === 404) {
            return of({ ...ENTITY_QUESTIONS_FEATURE_OFF, entityId });
          }
          return throwError(() => error);
        }),
      );
  }
}
